var moduleMap = {
	"./noop": function() {
		return __webpack_require__.e(684).then(function() { return function() { return (__webpack_require__(4684)); }; });
	},
	"./react": function() {
		return __webpack_require__.e(668).then(function() { return function() { return (__webpack_require__(5668)); }; });
	},
	"./react-dom": function() {
		return __webpack_require__.e(356).then(function() { return function() { return (__webpack_require__(2356)); }; });
	},
	"./next/router": function() {
		return __webpack_require__.e(468).then(function() { return function() { return (__webpack_require__(6704)); }; });
	},
	"./collection-form": function() {
		return __webpack_require__.e(946).then(function() { return function() { return (__webpack_require__(2946)); }; });
	},
	"./pages-map": function() {
		return __webpack_require__.e(272).then(function() { return function() { return (__webpack_require__(9891)); }; });
	},
	"./pages-map-v2": function() {
		return __webpack_require__.e(348).then(function() { return function() { return (__webpack_require__(3728)); }; });
	},
	"./pages/collection-form/CollectionFormPageMFE": function() {
		return __webpack_require__.e(946).then(function() { return function() { return (__webpack_require__(2946)); }; });
	},
	"./pages/collection-form/[formId]": function() {
		return __webpack_require__.e(728).then(function() { return function() { return (__webpack_require__(2728)); }; });
	},
	"./pages/success/index": function() {
		return __webpack_require__.e(624).then(function() { return function() { return (__webpack_require__(2624)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope, remoteEntryInitOptions) {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
__webpack_require__(1508)

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});